import z from "zod";
import { FILE_FILING_COLLECTIONS, fileFilingNeedsRecord } from "../../files/file-filing-target";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

/**
 * Filing one inbox file by hand: the collection, the project, and the record within it.
 *
 * The record is nullable in the shape and required by the rule, because which of the two it is
 * depends on the collection — a project document is addressed by the project alone, everything else
 * needs the row it hangs on. Saying that as a refinement rather than as two schemas keeps the form
 * one form, which is what the picker is.
 */
export const fileFilingSchema = z
	.object({
		collection: z.enum(FILE_FILING_COLLECTIONS),
		projectId: z.uuid(),
		recordId: ZodStringNullable,
	})
	.superRefine((value, ctx) => {
		if (!fileFilingNeedsRecord(value.collection) || value.recordId) return;
		ctx.addIssue({
			code: "custom",
			path: ["recordId"],
			message: "a record has to be chosen for this collection",
		});
	});

export type FileFilingSchema = z.infer<typeof fileFilingSchema>;
